import { ResourceType } from "@common/types/auditLog";
import { APIProcessName, SQSProcessName } from "../process-names";
import { HistoryGroupBy } from "./history-fields";
import type { HistorySourceTypeConfig } from "./history-source-config";
import { DOCUMENT_DISPLAY_FIELDS } from "./source-fields";
import { TRANSACTION_FIELDS } from "./transaction-sources";

export const integrationSources: HistorySourceTypeConfig[] = [
    {
        sourceType: SQSProcessName.MERCURY_ACCOUNTS_SYNC,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
            {
                resourceType: ResourceType.FINANCIAL_DOCUMENT,
                fields: DOCUMENT_DISPLAY_FIELDS,
                resolveEntity: true,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: SQSProcessName.GUSTO_ACCOUNT_SYNC,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: SQSProcessName.ADP_RUN_ACCOUNT_SYNC,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: SQSProcessName.RAMP_TRANSACTIONS_SYNC,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: SQSProcessName.PAYPAL_SYNC,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: SQSProcessName.BILLCOM_SYNC,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: SQSProcessName.PLAID_INITIAL_TRANSACTION_IMPORT,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: SQSProcessName.PLAID_TRANSACTION_IMPORT,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: SQSProcessName.STRIPE_TRANSACTIONS_SYNC,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: APIProcessName.PLAID_WEBHOOK_SYNC_UPDATES_AVAILABLE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: APIProcessName.PLAID_WEBHOOK_DEFAULT_UPDATE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: APIProcessName.PLAID_WEBHOOK_HISTORICAL_UPDATE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: APIProcessName.PLAID_WEBHOOK_TRANSACTIONS_REMOVED,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TRANSACTION,
                fields: TRANSACTION_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
];
